import { graphql } from '@/gql'

export const DivisionsQuery = graphql(/* GraphQL */ `
  query OrganisationDivisions($organisation: ID!, $first: Int!, $page: Int!) {
    organisation(id: $organisation) {
      divisions(first: $first, page: $page) {
        data {
          id
          name
          avatar
          trustedContacts {
            paginatorInfo {
              total
            }
          }
          teamMembers {
            paginatorInfo {
              total
            }
          }
          address {
            city
            country {
              name
            }
          }
        }
        paginatorInfo {
          ...PaginatorInfoFragment
        }
      }
    }
  }
`)
